import { getFetch, postFetch, postFormFetch, getJsonp } from '../util/service'
import { http } from '../util/axios'

//查询卖家本周还能发送促销次数
export function getSendSaleCount() {
	const data = getFetch('/sellercrm/recoder/getSendCount.do')
	return data
}

//获取固定营销分组列表
export function getPromotionGroups() {
	const data = getFetch('/sellercrm/recoder/getSysRecoderList.do')
	return data
}
//发送优惠券
export function getSendCoupon(params) {
	const data = postFormFetch('/sellercrm/group/sendCoupon.do', params)
	return data
}
//查询买家数量
export function getBuyerCount(groupId) {
	const data = getFetch('/sellercrm/group/queryCountByGroupId.do?groupId=' + groupId)
	return data
}
//店铺新品
export function getStoreNewProd() {
	const data = postFormFetch('/sellercrm/group/queryProdNew.do')
	return data
}
//确认发送
export function getSendStoreNewProd(itemcodes, groupId, msgType, msgContent, sendDate) {
	const data = getFetch(`/sellercrm/group/sendProdNew.do?itemcodes=${itemcodes}&groupId=${groupId}&msgType=${msgType}&msgContent=${encodeURI(msgContent)}&sendDate=${sendDate}`)
	return data
}
//限时限量
export function getLimitTime() {
	const data = postFormFetch('/sellercrm/group/queryPeriodAndLimit.do')
	return data
}
//店铺秒杀、限时限量、拼团活动 先获取活动信息
export function getActivityInfo(promoType) {
	const data = promoType == '' ? getFetch('/sellercrm/group/queryActivityList.do') : getFetch(`/sellercrm/group/queryActivityList.do?promoType=${promoType}`)
	return data
}
// 限时限量 表格展示内容
export function getLimitTimeInfo(promoId) {
	const data = getFetch(`/sellercrm/group/queryProdByPromoId.do?promoId=${promoId}`)
	return data
}
//确定发送
export function getSendLimitTimeProd(itemcodes, groupId, promoId, msgType, msgContent, sendDate) {
	const data = getFetch(`/sellercrm/group/sendPeriodAndLimit.do?itemcodes=${itemcodes}&groupId=${groupId}&promoId=${promoId}&msgType=${msgType}&msgContent=${encodeURI(msgContent)}&sendDate=${sendDate}`)
	return data
}
//店铺秒杀 表格展示内容
export function getSecondTableInfo(promoId, promoType, pageNum, pageSize) {
	const data = getFetch(`/sellercrm/group/queryActivityGoods.do?promoId=${promoId}&promoType=${promoType}&pageNum=${pageNum}&pageSize=${pageSize}`)
	return data
}
//确定发送
export function getSendSecondProd(itemcodes, groupId, promoId, promoType, msgType, msgContent, sendDate) {
	const data = getFetch(`/sellercrm/group/sendImAndMsg.do?itemcodes=${itemcodes}&groupId=${groupId}&promoId=${promoId}&promoType=${promoType}&msgType=${msgType}&msgContent=${encodeURI(msgContent)}&sendDate=${sendDate}`)
	return data
}
//发送产品 表格展示内容
export function getSendTableProdInfo(pageNo, type, size, groupId, itemcode, catePubId, prodGroupId) {
	const data = getFetch(`/sellercrm/group/crmProdList.do?pageNo=${pageNo}&type=${type}&size=${size}&groupId=${groupId}&itemCode=${itemcode}&catePubId=${catePubId}&prodGroupId=${prodGroupId}`)
	return data
}

// 国家查询
export function getCountryList(params) {
	const data = getFetch(`/sellercrm/common/countryList.do?groupType=${params.groupType}`)
	return data
}
// 全部买家分页查询
export function getAllBuyersList(params) {
	const data = postFormFetch('/sellercrm/mybuyer/buyerlist.do', params)
	return data
}

// 创建买家组前查询买家数量
export function getQueryCountBuyer(params) {
	const data = postFormFetch('/sellercrm/group/queryCountbygroup.do', params)
	return data
}
// 创建买家组
export function getQueryCountbygroup(params) {
	const data = postFormFetch('/sellercrm/group/savebuyergroup.do', params)
	return data
}

// 单个或批量加入黑名单
export function getAddBlackBuyer(params) {
	const data = getFetch(`/sellercrm/black/addBlackBuyer.do?buyerid=${params.buyerid}&inpBlackReason=${params.inpBlackReason}&addForBatch=${params.addForBatch}`, params)
	return data
}
// 批量移除黑名单
export function getRemoveBlackBuyer(params) {
	const data = getFetch('/sellercrm/black/removeBlackBuyer.do', params)
	return data
}

//卖家自主营销
//推广产品列表
export function extensionProdList(pageNo, pageSize) {
	const data = getFetch(`/sellerextend/api/extend-product/query-page?pageNo=${pageNo}&pageSize=${pageSize}`)
	return data
}

//删除推广产品
export function deleExtensionProd(params) {
	const data = postFetch('/sellerextend/api/extend-product/del', params)
	return data
}


//类目查询
export function prodCategoryList() {
	const data = getFetch('/sellerextend/api/product/cate-list')
	return data
}

//产品组查询
export function prodGroupList() {
	const data = getFetch('/sellerextend/api/product/group-list')
	return data
}

//新建推广商品列表
export function extensionProdTable(params) {
	const data = postFetch('/sellerextend/api/product/query-product-page', params)
	return data
}

//推广详情
export function extensionProdDetail(params) {
	const data = postFetch('/sellerextend/api/extend-product/query-result-page', params)
	return data
}

//商品信息查询
export function hoverProdInfo(itemcode) {
	const data = postFetch(`/sellerextend/api/product/product-info?itemCode=${itemcode}`)
	return data
}


//生成链接
export function createProdUrl(params) {
	const data = postFetch('/sellerextend/api/extend-product/save', params)
	return data
}

//渠道列表
export function channelTableList(params) {
	const data = postFetch('/sellerextend/api/extend-result/query-result-channel', params)
	return data
}

//渠道total数据
export function channelTotalList(params) {
	const data = postFetch('/sellerextend/api/extend-result/channel-result-total', params)
	return data
}

//渠道详情
export function channelTableDetail(params) {
	const data = postFetch('/sellerextend/api/extend-result/query-channel-detail', params)
	return data
}

//商品列表
export function prodTableList(params) {
	const data = postFetch('/sellerextend/api/extend-result/query-result-product', params)
	return data
}

//商品total数据
export function prodTotalList(params) {
	const data = postFetch('/sellerextend/api/extend-result/product-result-total ', params)
	return data
}

//商品详情
export function prodTableDetail(params) {
	const data = postFetch('/sellerextend/api/extend-result/query-product-detail', params)
	return data
}

//查询是否购买服务
export function hasPerssion() {
	const data = postFetch('/sellercrm/group/hasPerssion3009.do')
	return data
}

//查询一级类目列表
export function getFirstCateList() {
	const data = postFetch('/sellercrm/common/firstCateList.do')
	return data
}

//查询产品分组列表
export function getProductGroupList() {
	const data = postFetch('/sellercrm/common/prodGroupList.do')
	return data
}

//即时聊天工具相关
export function getDHtalker(uid) {
	const data = getJsonp(`https://www.dhtalker.com/api/query.do?act=robotState&uid=${uid}`)
	return data
}

//获取询盘列表
export function getInquiryList(params) {
	const data = postFetch('/sellerextend/api/inquiries/query-inquiries-orders', params)
	return data
}
//置为垃圾询盘
export function getUpdateInquiry(id) {
	const data = getFetch(`/sellerextend/api/inquiries/update-inquiries-orders?inquiriesOrdersId=${id}&operateType=0`)
	return data
}

//诚信保障金详情
export function securityFundDetail() {
	const data = postFetch('/securityfund/account/detail')
	return data
}
//保障金开通
export function securityFundOpen(params) {
	const data = postFormFetch('/securityfund/account/open', params)
	return data
}
//退出保障金
export function securityFundQuit() {
	const data = postFetch('/securityfund/account/quit')
	return data
}
//开通买家保障
export function truthDeliverOpen() {
	const data = postFetch('/securityfund/account/truthDeliver/open')
	return data
}
//检测买家是否加入如实发货60天
export function truthDeliverCheck() {
	const data = postFetch('/securityfund/account/truthDeliver/check')
	return data
}
//退出买家保障
export function truthDeliverQuit() {
	const data = postFetch('/securityfund/account/truthDeliver/quit')
	return data
}
//开通 放心购
export function happyShoppingOpen(params) {
	const data = postFormFetch('/securityfund/account/happyShopping/open', params)
	return data
}
//退出放心购
export function happyShoppingQuit() {
	const data = postFetch('/securityfund/account/happyShopping/quit')
	return data
}

//修改手机号验证页面初始化
export function phoneVerityDetail() {
	const data = postFetch('/merchant/phoneVerifyInit.do')
	return data
}
//验证安全问题
export function checkSecurityAnswer(params) {
	const data = postFormFetch('/merchant/iframe_checkanswer.do', params)
	return data
}
//旧手机发送验证码 
export function sendOldMobileVerityCode() {
	const data = postFormFetch('/merchant/jquerysendOldMobileVerifycode.do')
	return data
}
//校验旧手机验证码
export function checkOldMibleVerityCode(code) {
	const data = getFetch('/merchant/jqueryOldMobileVerifycode.do?verifycode=' + code)
	return data
}
//验证码校验
export function checkOldImgVerityCode(code) {
	const data = getFetch('/merchant/checkChangeMobileVerifycode.do?verifycode=' + code)
	return data
}
//新手机号发送短信验证码
export function sendNewMobileVerityCode(code) {
	const data = postFormFetch('/merchant/jquerysendverifycode.do?modifyType=1&mobilephone=' + code)
	return data
}

export function realNameVerification(params) {
	const data = postFormFetch('/merchant/phoneVerification.do', params)
	return data
}

//保存验证
export function saveSubmit(mobile, code, imgcode) {
	const data = postFormFetch(`/merchant/checkVerifyCodeNew.do?isblank=true&mobilephone=${mobile}&mobilephoneCode=${code}&verifycode=${imgcode}`)
	return data
}
//提前放款开通信息接口
export function loanBaseInfo() {
	const data = postFormFetch(`/securityfund/loan/api/baseinfo`)
	return data
}
//提前当款开通接口
export function openLoan() {
	const data = postFormFetch(`/securityfund/loan/api/openSellerLoan`)
	return data
}
//提前当款退出接口
export function quitLoan() {
	const data = postFormFetch(`/securityfund/loan/api/quitSellerLoan`)
	return data
}
//缴费页面初始化
export function paymentInit(id) {
	const data = postFormFetch(`/merchant/category/payload.do?categoryId=${id}`)
	return data
}
//缴费前安全校验
export function payCheck(id) {
	const data = postFormFetch(`/merchant/category/payCheck.do?categoryId=${id}`)
	return data
}
//缴费记录
export function recordList(pageNo, pageSize) {
	const data = getFetch(`/merchant/category/category_fee_list.do?pageNo=${pageNo}&pageSize=${pageSize}`)
	return data
}

export function getExternalFiles(uri, params) {
	return http.get(uri, { ...params })
}


//登录注册升级

//验证密码接口
export function chkRequirePassword(val) {
	const data = getFetch(`/merchant/register/passwordAjaxJson.do?clientid=password1&password1=${val}&isblank=true`)
	return data
}

//验证密码安全等级接口
export function chkRequirePasswordLevel(val) {
	const data = getFetch(`/merchant/register/checkPassword.do?password=${val}&isblank=true`)
	return data
}

//图片验证码校验
export function chkImgVerityCode(code) {
	const data = getFetch('/merchant/activity/checkCreateImage.do?checkCode=' + code)
	return data
}

//找回密码验证用户名
export function chkUserName(val) {
	const data = postFormFetch(`/merchant/findpassword/checkName.do?domainName=${val}`)
	return data
}
//找回密码 发送短信验证码或者邮箱验证码
export function sendPwdVerifyCodePwd(params) {
	const data = postFormFetch(`/merchant/findpassword/sendPwdVerifyCodePwd.do`, params)
	return data
}
//找回密码 短信验证码校验
export function mobileValidNew(params) {
	const data = postFormFetch(`/merchant/findpassword/mobileValidNew.do`, params)
	return data
}
//找回密码 保存新密码
export function chgPwdSave(params) {
	const data = postFormFetch(`/merchant/findpassword/chgPwdSave.do`, params)
	return data
}
//找回用户名 发送短信验证码或者邮箱验证码 
export function sendfindUserCode(params) {
	const data = postFormFetch(`/merchant/findUsername/sendfindUserCode.do`, params)
	return data
}
//找回用户名短信验证码校验
export function findUserMobileValid(params) {
	const data = postFormFetch(`/merchant/findUsername/findUserMobileValid.do`, params)
	return data
}
//找回用户名邮箱验证码校验
export function findUserEmailValid(params) {
	const data = postFormFetch(`/merchant/findUsername/findUserEmailValid.do`, params)
	return data
}
//找回用户名 用户名接口
export function findUserNames(params) {
	const data = postFormFetch(`/merchant/findUsername/findUserNames.do`, params)
	return data
}
//判断手机号或者邮箱是否存在
export function findUsernameValid(params) {
	const data = postFormFetch(`/merchant/findUsername/findUsernameValid.do`, params)
	return data
}
//注册页面初始化
export function pageLoadNew() {
	const str = window.location.search
	const data = postFormFetch(`/merchant/register/pageLoadNew.do${str?str:''}`)
	return data
}
//注册发送短信验证码
export function sendVerifyCodeNew(params) {
	const data = postFormFetch(`/merchant/register/sendVerifyCodeNew.do`, params)
	return data
}
//注册短信验证码校验
export function verifyCodeNewValid(params) {
	const data = postFormFetch(`/merchant/register/verifyCodeNewValid.do`, params)
	return data
}
//注册 手机号关联校验
export function checkPhoneEmailValid(params) {
	const data = postFormFetch(`/merchant/register/checkPhoneEmailValid.do`, params)
	return data
}
//注册 用户名校验
export function checkidNew(params) {
	const data = postFormFetch(`/merchant/register/checkidNew.do`, params)
	return data
}
//注册发送邮箱验证码
export function sendRegisterEmail(params) {
	const data = postFormFetch(`/merchant/register/sendRegisterEmail.do`, params)
	return data
}
//注册发送邮箱验证码
export function validRegisterEmail(params) {
	const data = postFormFetch(`/merchant/register/validRegisterEmail.do`, params)
	return data
}
//保存注册信息
export function saveNew(params) {
	const str = window.location.search
	const data = postFormFetch(`/merchant/register/saveNew.do?${str}`, params)
	return data
}
//缴费礼包列表
export function annualList() {
	const data = postFormFetch(`/merchant/annual_pay_new.do`, )
	return data
}
//礼包缴费接口
export function payAnnual(params) {
	const data = postFormFetch(`/merchant/payAnnual.do`, params)
	return data
}
//生成微信公众号二维码
export function wechatCode() {
	const data = postFormFetch(`/merchant/register/wechatCode.do`)
	return data
}
//用户是否已经扫码
export function wechatCodeValid() {
	const data = postFormFetch(`/merchant/register/wechatCodeValid.do`)
	return data
}
